export function getView(isValid, isRequired, hideNext, questionId) {
  if (hideNext) return false

  return isValid || !isRequired
}
